import Vue from 'vue';
import Vuex from 'vuex';
// State modules
import appSettings from './modules/appSettings';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    appSettings,
  },
  state: {
    user: null,
    apiRoot: process.env.VUE_APP_API_ROOT,
    client: null,
    routerBase: '/admin',
    ready: false,
    flashMessages: [],
    alertMessages: [],
    requestedRoute: null,
    liveswitchDeviceId: '',
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = null;
    },
    setClient(state, client) {
      state.client = client;
    },
    setReady(state) {
      state.ready = true;
    },
    postFlashMessage(state, payload) {
      state.flashMessages.push({
        type: payload.type,
        text: payload.text,
      });
      while (state.flashMessages.length > 10) {
        state.flashMessages.shift();
      }
    },
    showAlert(state, payload) {
      state.alertMessages.push(_.pick(payload, [
        'title',
        'message',
      ]));
      state.alertMessages = state.alertMessages.slice(-1);
    },
    setRequestedRoute(state, requestedRoute) {
      state.requestedRoute = requestedRoute;
    },
    setLiveswitchDeviceId(state, liveswitchDeviceId) {
      state.liveswitchDeviceId = liveswitchDeviceId;
    },
  },
  getters: {
    userIsLoggedIn(state) {
      return !!state.user;
    },
    userName(state) {
      if (state.user) {
        return `${state.user.firstname} ${state.user.lastname}`;
      }
      return '';
    },
    user(state) {
      return state.user;
    },
    imageServer(state) {
      return state.imageServer;
    },
    stateReady(state) {
      return state.ready;
    },
    flashMessages(state) {
      return state.flashMessages;
    },
    alertMessages(state) {
      return state.alertMessages;
    },
    requestedRoute(state) {
      return state.requestedRoute;
    },
    apiRoot(state) {
      return state.apiRoot;
    },

  },
  actions: {
    async updateLocale({ dispatch, commit, state }, locale) {
      dispatch('appSettings/update', {locale: locale});
    },
  },
  strict: debug,
});
